import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private apiCount = 0;
  private pinnedCount = 0;
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();

  private messageSubject = new BehaviorSubject<string | null>(null);
  message$ = this.messageSubject.asObservable();

  constructor() { }

  showLoader(message?: string | null, pinned: boolean = false) {
    if (pinned) {
      this.pinnedCount++;
      if (message) this.messageSubject.next(message);
    } else {
      if (this.apiCount === 0 && this.pinnedCount === 0) {
        this.isLoadingSubject.next(true);
      }
      this.apiCount++;
      if (message) this.messageSubject.next(message);
    }

    if (this.apiCount + this.pinnedCount > 0) this.isLoadingSubject.next(true);
  }

  hideLoader(pinned: boolean = false) {
    if (pinned) {
      if (this.pinnedCount > 0) this.pinnedCount--;
      if (this.pinnedCount === 0) this.messageSubject.next(null);
    } else {
      if (this.apiCount > 0) this.apiCount--;
    }

    if (this.apiCount + this.pinnedCount === 0) {
      this.isLoadingSubject.next(false);
    }
  }
}
